import { Component, OnInit, ElementRef, OnDestroy, AfterViewInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialogRef } from '@angular/material/dialog';
import * as consts from '../common/consts';
import * as utils from '../common/utils';
import { ZIndexMngr } from '../common/ZIndexMngr';
import { Animations } from '@core_n/Animations';
import { aspMngr } from '@core_n/asp/AspMngr';
import { ObjectType } from '@core_n/asp/AspObject';
import { SensorsCorePool } from '@core_n/asp/SensorsCorePool';
import { mainMapMngr } from '@core_n/asp/MapMngr';
import { AppInjector } from '@core_n/common/inject';
import { AroSensorService } from 'src/app/aro/aro-sensor.service';
import { SensorObject } from 'src/app/asp/SensorObject';
import { dialogType } from '@core_n/enums';

const MAX_SEARCH_RESULTS = 100;
const HIGHLIGHT_COLOR = 'orange';

@Component({
  selector: 'show-errors-dialog',
  templateUrl: './show-errors.component.html',
  styleUrls: ['./show-errors.component.scss'],
  animations: [
    Animations.WindowOpenCloseFadeHeight
  ]
})
export class ShowErrorsDialogComponent extends ZIndexMngr implements OnInit, OnDestroy, AfterViewInit {

  
  errorsList = new Array<any>();

  constructor(public dialogRef: MatDialogRef<ShowErrorsDialogComponent>,
    private domSanitizer: DomSanitizer,
    elementRef: ElementRef) {
    super(elementRef);

    let self = this;
    setInterval(function () { self.refresh() }, consts.DIALOG_REFRESH_INTERVAL);
  }

  static createDialogConfig(upperBarHeight: number) {
    return utils.createDialogConfig(false, false, dialogType.showErrors,
      { top: `${upperBarHeight + 5}px`, right: `80px` });
  }

  ngOnInit() {
    this.errorsList = JSON.parse(localStorage.getItem(consts.LOCAL_STORAGE_ALL_ERR_NOTIFICATION));
    this.dialogRaise();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.windowVisible.next(true);
    })
  }

  ngOnDestroy(): void {
    localStorage.setItem(consts.LOCAL_STORAGE_NEW_ERR_NOTIFICATION, JSON.stringify(false));
    if (this.errorsList) {
      this.errorsList.map(u => u.isNew == true ? u.isNew = false : u.isNew = false);
      localStorage.setItem(consts.LOCAL_STORAGE_ALL_ERR_NOTIFICATION, JSON.stringify(this.errorsList));
    }
    this.dialogClosed();
  }

  protected refresh(): void {
    let list = JSON.parse(localStorage.getItem(consts.LOCAL_STORAGE_ALL_ERR_NOTIFICATION));
    if (!list) {
      this.errorsList = [];
      return;
    }
    this.errorsList = list;
  }

  setCenter(cameraName: string) {
    let sensor = (aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool).name2Obj.get(cameraName.toLowerCase());
    if (!sensor)
      sensor = (aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool).name2Obj.get((cameraName.toLowerCase()).toLowerCase() + ".stream");     
    mainMapMngr.setMapCenter(sensor.geometry);
  }

  openAro(cameraName: string) {
    let sensor = (aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool).name2Obj.get(cameraName.toLowerCase());
    if (!sensor)
      sensor = (aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool).name2Obj.get((cameraName.toLowerCase()).toLowerCase() + ".stream");    
    AppInjector.get(AroSensorService).showWindow(sensor as SensorObject);
  }

  deleteAll() {
    localStorage.removeItem(consts.LOCAL_STORAGE_ALL_ERR_NOTIFICATION);
  }
}
